import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 状态管理
export default new Vuex.Store({
  state: {
    userMsg: {},
    listPagePars: new Map(),
    shoppingNum: 0
  },
  mutations: {
    SAVE_LIST_PAGE_PARS: (state, { path, pars }) => {
      state.listPagePars.set(path, pars)
    },
    UPDATE_USERMSG: (state, obj) => {
      state.userMsg = obj
    },
    SET_SHOPPINGNUM: (state, num) => {
      state.shoppingNum = num
    }
  },
  actions: {
    save_list_page_pars ({commit}, { path, pars }) {
      commit('SAVE_LIST_PAGE_PARS', { path, pars })
    },
    update_userMsg ({commit}, obj) {
      commit('UPDATE_USERMSG', obj)
    },
    set_shoppingNum ({commit}, num) {
      commit('SET_SHOPPINGNUM', num)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js